import { environment } from "src/environments/environment";
import { Utilerias } from "../helpers/Utilerias";
import { TblCatUsuario, TblRelPreguntaRespuesta, TblTranRespuesta } from "../types/Tables";
import { EstacionesTVADB } from "./EstacionesTVADB";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class MasterDB {
  static getMenu(http, db) {
    return MasterDB.getUsuarioSesion(db)
      .then(res => {
        return Utilerias.httpRequest(http, 'GetCatalogoMenus', 'get', { idEmpleado: res.IdEmpleado })
          .then(res => {
            Utilerias.showLoader(false);
            return res;
          });
      });
  }

  static loadMenu(db: EstacionesTVADB) {
    return db.GetLocalArray('TblCatMenu')
      .then(res => {
        return res;
      })
  }

  static getUsuarioSesion(bd: EstacionesTVADB): Promise<TblCatUsuario> {
    return bd.GetLocalArray('TblCatUsuario')
      .then(res => {
        return res[0];
      })
  }

  static postlocalRubro(rubro, db: EstacionesTVADB) {
    let prom;
    return db.GetLocalObject('TblTranRubro', 'IdRubro', rubro.IdRubro)
      .then(result => {
        if (result) {
          prom = db.putLocalobject('TblTranRubro', rubro);
        }
        else {
          prom = db.postLocalobject('TblTranRubro', rubro);
        }
        return prom;
      })
  }

  static postlocalPregunta(pregunta, db: EstacionesTVADB) {
    let prom;
    return db.GetLocalObject('TblTranPregunta', 'IdPregunta', pregunta.IdPregunta)
      .then(result => {
        if (result) {
          prom = db.putLocalobject('TblTranPregunta', pregunta);
        }
        else {
          prom = db.postLocalobject('TblTranPregunta', pregunta);
        }
        return prom;
      })
  }

  static postlocalRespuesta(respuesta, db: EstacionesTVADB) {
    return db.postLocalobject('TblTranRespuesta', respuesta);
  }

  static postRespuesta(data: any, db: EstacionesTVADB) {
    let respuesta = {
      IdRelacion: data.IdRelacion,
      IdRespuesta: data.IdRespuesta,
      IdPregunta: data.IdPregunta,
      IdRevision: data.IdRevision,
      IdEmpleadoContesta: data.IdEmpleadoContesta,
      Calificacion: data.Calificacion,
      Texto: data.Texto,
      FechaMod: data.FechaMod,
      FechaSync: null
    };
    let pregunta = {
      IdPregunta: data.IdPregunta,
      IdRevision: data.IdRevision,
      Calificacion: data.Calificacion,
      FechaMod: data.FechaMod,
      FechaSync: null
    };
    let rubro = {
      IdRubro: data.IdRubro,
      IdRevision: data.IdRevision,
      Calificacion: data.Calificacion,
      IdEstatus: 1,
      IdNivelValidacion: 1,
      FechaMod: data.FechaMod,
      FechaSync: null
    };
    var tables = [
      db.TblTranRevision,
      db.TblTranChecklist,
      db.TblTranBloque,
      db.TblTranRubro,
      db.TblTranPregunta,
      db.TblTranRespuesta,
    ];
    return db.transaction('rw', tables, function () {
      return Promise.all([
        MasterDB.postlocalRespuesta(respuesta, db),
        MasterDB.postlocalPregunta(pregunta, db),
        MasterDB.postlocalRubro(rubro, db)
      ]).catch(error => {
        console.error(error);
        alert(environment.errorMessage);
      });
    });
  }

  static joinTables(tbl1, tbl2, key) {
    for (const row of tbl1) {
      Object.assign(row, tbl2.find(x => x[key] == row[key]));
    }
    return tbl1;
  }

  static getLocalRespuestas(db: EstacionesTVADB) {
    return Promise.all([
      db.TblCatRespuesta.toArray(),
      db.TblCatTipoInput.toArray()
    ]).then(result => {
      let respuestas: any[] = result[0];
      for (const item of respuestas) {
        item.type = result[1].find(x => x.IdTipoInput == item.IdTipoInput).Descripcion;
      }
      return respuestas;
    });
  }

  static getLocalChecklist(idChecklist) {
    let bloques;
    let rubros;
    let preguntas;
    let respuestas;
    let db = new EstacionesTVADB();
    return Promise.all([
      db.TblCatChecklist.filter(x => x.IdChecklist == idChecklist).toArray(),
      db.TblCatBloque.filter(x => x.IdChecklist == idChecklist).toArray(),
      this.getLocalRespuestas(db)
    ]).then(result => {
      bloques = result[1];
      respuestas = result[2];
      let idBloques = bloques.map(x => { return x.IdBloque });
      return db.TblCatRubro.filter(x => idBloques.includes(x.IdBloque)).toArray()
    }).then(result => {
      rubros = result;
      let idRubros = result.map(x => { return x.IdRubro });
      return db.TblCatPregunta.filter(x => idRubros.includes(x.IdRubro)).toArray()
    }).then(result => {
      preguntas = result;
      let idPreguntas = result.map(x => { return x.IdPregunta });
      return Promise.all([
        db.TblRelPreguntaRespuesta.filter(x => idPreguntas.includes(x.IdPregunta)).toArray(),
        db.TblTranRespuesta.filter(x => idPreguntas.includes(x.IdPregunta)).toArray()
      ]);
    }).then(result => {
      let join;
      let relPreguntaRespuestas: TblRelPreguntaRespuesta[] = result[0];
      let tranRespuestas: TblTranRespuesta[] = result[1];
      let relacionesPregunta;
      for (const bloque of bloques) {
        bloque.rubros = rubros.filter(x => x.IdBloque == bloque.IdBloque);
        for (const rubro of bloque.rubros) {
          rubro.preguntas = preguntas.filter(x => x.IdRubro == rubro.IdRubro);
          for (const pregunta of rubro.preguntas) {
            relacionesPregunta = relPreguntaRespuestas
              .filter(x => x.IdPregunta == pregunta.IdPregunta);
            join = this.joinTables(relacionesPregunta, respuestas, 'IdRespuesta');
            join = this.joinTables(join, tranRespuestas, 'IdRelacion');
            for (const r of join) {
              r.Checked = r.IdRevision ? true : false;
            }
            pregunta.respuestas = join;
          }
        }
      }
      return bloques;
    });
  }

  static login(http, idEmpleado) {
    let db = new EstacionesTVADB();
    let data = {
      login: {
        IdEmpleado: idEmpleado,
        Token: localStorage['acTkn'],
        IdTipoAplicacion: 1
      }
    };

    console.log('1.- Validando el usuario');
    return Utilerias.httpRequest(http, 'Login', 'post', data)
      .then(result => {
        localStorage['jwt'] = result['Token'];
        console.log('2.- Creando la base de datos');
        return db.open()
          .then(() => {
            return result;
          });
      })
      .then(result => {
        console.log('3.- Guardando el usuario');
        return db.postLocalobject('TblCatUsuario', result);
      })
      .then(() => {
        let params: any[] = [
          data.login.IdEmpleado
        ];
        console.log('4.- Guardando catalogos');
        return MasterDB.getInitialCatalogs(db, http, params);
      })
      .then(res => {
        Utilerias.showLoader(false);
        console.log('5.- El proceso del login se realizo exitosamente');
        return res;
      })
      .catch(error => {
        Utilerias.showLoader(false);
        console.error('Error al procesar el login.');
        console.error(error);
      });
  }


  static getLocalRevision(idRevision) {
    let result = { revision: {} };
    let db = new EstacionesTVADB();
    return db.GetLocalObject('TblTranRevision', 'IdRevision', idRevision)
      .then(data => {
        if (data) {
          result.revision = data;
        } else {
          result.revision = {
            IdRevision: idRevision
          };
        }
        return result;
      });
  }

  static getLocalRevisiones() {
    let localDB = new EstacionesTVADB();
    return Promise.all([
      localDB.GetLocalArray('TblTranRevision'),
      localDB.GetLocalArray('TblCatEtapaRevision'),
      localDB.GetLocalArray('TblCatEstacion')
    ]).then(function (tbls) {
      var obj;
      for (var rev of tbls[0]) {
        obj = tbls[1].find(x => x.IdEtapa === rev.IdEtapa);
        rev.Etapa = {
          IdEtapa: rev.IdEtapa,
          Color: obj.Color,
          Descripcion: obj.Descripcion
        };
        obj = tbls[2].find(x => x.IdEstacion === rev.IdEstacion);
        rev.Estacion = {
          IdEstacion: rev.IdEstacion,
          Nombre: obj.Nombre
        };
      }
      return tbls[0];
    });
  }

  static postSyncData(data) {
    let db = new EstacionesTVADB();
    var tables = [
      db.TblCatUsuario,
      db.TblCatChecklist,
      db.TblCatBloque,
      db.TblCatRubro,
      db.TblCatPregunta,
      db.TblCatTipoRevision,
      db.TblCatEstacion,
      db.TblRelPreguntaRespuesta,
      db.TblTranRevision
    ];
    var catalogos = data.Catalogos;
    var relaciones = data.Relaciones;
    var transacciones = data.Transacciones;
    var revision = data;

    delete revision.Catalogos;
    delete revision.Relaciones;
    delete revision.Transacciones;

    let promises = [];
    if (revision.IsFirstSync) {
      promises = [
        db.postLocalobject('TblTranRevision', revision),
        db.postLocalArray('TblCatChecklist', catalogos.CatalogoChecklists),
        db.postLocalArray('TblCatBloque', catalogos.CatalogoBloques),
        db.postLocalArray('TblCatRubro', catalogos.CatalogoRubros),
        db.postLocalArray('TblCatPregunta', catalogos.CatalogoPreguntas),
        db.postLocalArray('TblRelPreguntaRespuesta', relaciones.RelacionPreguntaRespuesta),
        db.postLocalArray('TblRelRevisionChecklist', relaciones.RelacionRevisionChecklist)
      ];
    } else {
      promises = [
        db.putLocalobject('TblTranRevision', revision)
      ];
    }

    return db.transaction('rw', tables, function () {
      return Promise.all(promises);
    });
  }

  static getInitialCatalogs(db: EstacionesTVADB, http: HttpClient, params: object[]) {
    var tables = [
      db.TblCatTipoRevision,
      db.TblCatEtapaRevision,
      db.TblCatEstacion
    ];
    let calls: Promise<object>[] = [];
    let posts: Promise<object>[] = [];
    let methods = [

    ];
    for (const item of methods) {
      calls.push(Utilerias.httpRequest(http, item.method, 'get', item.data));
    }
    return Promise.all(calls).then(result => {
      result.forEach((item, index) => {
        posts.push(db.postLocalArray(methods[index].table, item));
      });
      return db.transaction('rw', tables, function () {
        return Promise.all(posts);
      });
    });
  }
}
